import React, { useEffect, useState } from "react";
import Table from "../../components/table/Table";
import _ from "lodash";
import {
  ButtonTableEdit,
  ButtonTableDelete,
  ButtonAdd,
  ButtonTableBulkDelete,
  ButtonDPad,
} from "../../components/buttons";
import InputLabel from "../../components/InputLabel";
import Pagination from "../../components/Pagination";
import ConfirmDeleteModal from "../../components/ConfirmDeleteModal";
import MachineGroupModal from "../../components/machine-master/MachineGroupModal";
import { useGroupHook, useGroupRelation } from "../../hooks/MachineGroupHook";
import MachineGroupServices from "../../services/MachineGroupServices";
import { errorStatusHandle } from "../../utils/error-utils";
import { changeOrder } from "../../utils/common-utils";
import { useDocumentTitle } from "../../hooks";
import { useDispatch, useSelector } from "react-redux";
import { getRouteBreadcrumb } from "../../services/BreadcrumbServices";
import * as ROUTES from "../../constants/routes";
import BackendLayout from "../../layouts/BackendLayout";
import {PageTitle, SelectInput, CheckboxInput, RedirectAlert} from "../../components";
import { getMachineGroupSetting } from "../../api/setting/pageApi";
import { setPageSettings } from "../../store/actions/pageActions";
import {
  clearPageLoading,
  resetAlert,
  setAlertSuccess,
  setPageLoading,
  clearButtonProcessing,
  setButtonProcessing,
} from "../../store/actions";
import { createGroupTree } from "../../utils/group-tree";
import { SuccessMessageAlert, ErrorMessageAlert } from "../../components";
import { updateUserSetting } from "../../services/user-master/UserSettingServices";
import { USER_SETTING_CATEGORIES } from "../../constants/app";
import {MACHINE_MASTER_GROUP_UPDATE_PAGE} from "../../constants/pageName";
import useRedirectPage from "../../hooks/useRedirectPage";

export default function MachineGroupUpdatePage() {
  useRedirectPage(MACHINE_MASTER_GROUP_UPDATE_PAGE);
  useDocumentTitle("設備グループマスタ更新 - 点検王");
  const dispatch = useDispatch();
  const breadcrumb = getRouteBreadcrumb(ROUTES.MACHINE_MASTER_GROUP_UPDATE);
  const initialModalData = {
    1: 0,
    2: 0,
    3: 0,
    4: 0,
    5: 0,
    active: true,
    id: 0,
  };

  const { groupLevels, reload, setReload } = useGroupHook();
  const [levelSelect, setLevelSelect] = useState(0);
  const {
    groupRelations,
    page,
    perPage,
    orderList,
    count,
    setPage,
    setPerPage,
    setOrderList,
    setGroupRelations,
  } = useGroupRelation(levelSelect, reload);
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [modalGroupData, setModalGroupData] = useState(initialModalData);
  const initialFormError = { error_message: "", errors: {} };
  const [formError, setFormError] = useState(initialFormError);
  const [deleteIds, setDeleteIds] = useState([]);
  const [processing, setProcessing] = useState(false);
  const groupSetting = useSelector((s) => s.app_settings.machine_group);
  const [groupsList, setGroupsList] = useState({});
  const [groupsChildren, setGroupsChildren] = useState({});
  const [confirmDeleteMessage, setConfirmDeleteMessage] = useState([]);
  const [confirmDeleteTitle, setConfirmDeleteTitle] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    dispatch(setPageLoading());
    getMachineGroupSetting()
      .then((pageSettings) => {
        dispatch(setPageSettings(pageSettings));
        setGroupsChildren(pageSettings.options.group_and_children);
        let grouplst = {
          1: [],
          2: [],
          3: [],
          4: [],
          5: [],
        };
        Object.entries(pageSettings.options.group_list).forEach((group) => {
          grouplst[group[0]] = group[1].map((v) => {
            return { value: v.id, label: v.name };
          });
        });
        if (pageSettings.user_setting?.setting) {
          setLevelSelect(pageSettings.user_setting.setting?.levelGroup);
        } else {
          setLevelSelect(1);
        }
        setGroupsList(grouplst);
        dispatch(clearPageLoading());
      })
      .catch((e) => {
        dispatch(clearPageLoading());
        errorStatusHandle(e);
      });
  }, [reload]);

  const handleCheckDelete = (e, index) => {
    const relations = [...groupRelations];
    if (index !== undefined) {
      relations[index].delete = !!e.target.checked;
    }
    setGroupRelations(relations);
  };

  const handleChangeLevel = (e) => {
    setLevelSelect(parseInt(e.target.value));
    if (errorMessage !== "" || successMessage !== "") {
      resetMessage();
    }
    updateSettings(parseInt(e.target.value));
  };

  const updateSettings = async (levelGroup) => {
    const formUserSettings = {
      levelGroup: levelGroup,
    };
    try {
      await updateUserSetting(
        formUserSettings,
        USER_SETTING_CATEGORIES.GROUP_UPDATE
      );
    } catch (e) {
      errorStatusHandle(e);
    }
  };

  const handleShowDeleteModal = (row, index) => {
    const groupLevel = `group_${levelSelect}`;
    if (row) {
      setDeleteIds([row["group_" + levelSelect].id]);
      let confirmTitle = "設備グループを削除しますか？";
      let confirmMessage = `${groupSetting[groupLevel]?.name}：${
        row["group_" + levelSelect]?.name
      }を削除します。`;
      confirmMessage = confirmMessage + "\nこの操作は元には戻せません。";
      setStateForDelete(confirmTitle, confirmMessage);
    } else {
      let deleteRows = _.filter(
        groupRelations,
        (group) => group.delete === true
      );
      if (deleteRows.length > 0) {
        let confirmTitle = "設備グループを一括削除しますか？";
        let confirmMessage =
          "選択された以下の設備グループを削除します。\nこの操作は元には戻せません\n";
        deleteRows.forEach((item) => {
          confirmMessage =
            confirmMessage +
            `\n${groupSetting[groupLevel]?.name}：${item[groupLevel]?.name}`;
        });
        setStateForDelete(confirmTitle, confirmMessage);
      }
    }
  };

  const setStateForDelete = (confirmTitle, confirmMessage) => {
    confirmMessage = confirmMessage + "\n\n削除してもよろしいでしょうか？";
    setConfirmDeleteTitle(confirmTitle);
    setConfirmDeleteMessage(confirmMessage);
    if (errorMessage !== "" || successMessage !== "") {
      resetMessage();
    }
    setDeleteModal(true);
  };

  const handleSort = (column) => {
    let currentOrder = changeOrder(orderList[column]);
    setOrderList({
      ...orderList,
      [column]: currentOrder,
    });
  };

  const handleAddModal = () => {
    setModalGroupData(initialModalData);
    setFormError(initialFormError);
    if (errorMessage !== "" || successMessage !== "") {
      resetMessage();
    }
    setAddModal(true);
  };

  const handleEditModal = (groupData) => {
    const modalData = {
      1: groupData.group_1?.id ?? 0,
      2: groupData.group_2?.id ?? 0,
      3: groupData.group_3?.id ?? 0,
      4: groupData.group_4?.id ?? 0,
      5: groupData.group_5?.id ?? 0,
      active: groupData["group_" + levelSelect]?.status,
      id: groupData["group_" + levelSelect].id,
    };
    modalData[levelSelect] = groupData["group_" + levelSelect].name;
    setModalGroupData(modalData);
    setFormError(initialFormError);
    if (errorMessage !== "" || successMessage !== "") {
      resetMessage();
    }
    setEditModal(true);
  };

  const handleSubmitAdd = (e) => {
    dispatch(setButtonProcessing("btn-update-group"));
    MachineGroupServices.addGroup(modalGroupData, levelSelect)
      .then((response) => {
        setProcessing(false);
        dispatch(setAlertSuccess(response));
        setFormError(initialFormError);
        setModalGroupData({ ...modalGroupData, [levelSelect]: "" });
        setReload(reload + 1);
        dispatch(clearButtonProcessing("btn-update-group"));
      })
      .catch((e) => {
        dispatch(clearButtonProcessing("btn-update-group"));
        if (e.response.status === 400) {
          dispatch(resetAlert());
          setFormError(e.response.data);
        }
        errorStatusHandle(e.response);
      });
  };

  const handleSubmitEdit = (e) => {
    dispatch(setButtonProcessing("btn-update-group"));
    MachineGroupServices.editGroup(modalGroupData, levelSelect)
      .then((response) => {
        setProcessing(false);
        dispatch(setAlertSuccess(response));
        setFormError(initialFormError);
        setReload(reload + 1);
        dispatch(clearButtonProcessing("btn-update-group"));
      })
      .catch((e) => {
        dispatch(clearButtonProcessing("btn-update-group"));
        if (e.response.status === 400) {
          dispatch(resetAlert());
          setFormError(e.response.data);
        }
        errorStatusHandle(e.response);
      });
  };

  const handleSubmitDelete = (e) => {
    if (processing) {
      return;
    }
    setProcessing(true);
    let ids = [...deleteIds];
    if (ids.length === 0) {
      let deleteRows = _.filter(
        groupRelations,
        (group) => group.delete === true
      );
      ids = deleteRows.map((row) => {
        return row["group_" + levelSelect].id;
      });
    }
    MachineGroupServices.deleteGroups(ids)
      .then((response) => {
        setDeleteIds([]);
        setDeleteModal(false);
        setReload(reload + 1);
        setSuccessMessage(response.message);
        setProcessing(false);
      })
      .catch((error) => {
        errorStatusHandle(error);
        if (error.status === 400) {
          let responseData = error.data;
          setErrorMessage(responseData.error_message);
          setDeleteModal(false);
        }
        setProcessing(false);
      });
  };

  const resetMessage = () => {
    setErrorMessage("");
    setSuccessMessage("");
  };

  const renderMessages = () => {
    if (successMessage !== "") {
      return (
        <SuccessMessageAlert className="mb-[16px]" success={successMessage} />
      );
    }
    if (errorMessage !== "") {
      return <ErrorMessageAlert className="mb-[16px]" error={errorMessage} />;
    }
    return;
  };

  return (
    <BackendLayout breadcrumb={breadcrumb} sidebar={true}>
      <PageTitle title={breadcrumb[breadcrumb.length - 1]?.menu} />
      <ButtonDPad />
      <RedirectAlert />
      {renderMessages()}
      <div className="machine-update__content min-w-full w-fit pr-6">
        <div className="flex items-center md:mr-1.5 xl:mr-[2%] w-full">
          <InputLabel
            htmlFor="file_name_id"
            className="page__search-form--label xl:w-[200px] w-[160px]"
            text="フィールド名"
          />
          <SelectInput
            value={levelSelect}
            options={groupLevels ?? []}
            name="file_name"
            className="xl:w-[280px] w-[240px]"
            onChange={(e) => handleChangeLevel(e)}
          />
        </div>

        <div className="flex justify-between items-center md:px-1 md:py-4 xl:py-4"></div>
        <div className="pr-6 w-fit lg:pr-0 lg:w-full">
          <div className="relative rounded-[8px] border border-tenken-gray-300">
            <Table striped>
              <Table.Head className="">
                {1 <= levelSelect && (
                  <Table.HeadCell
                    sortable
                    order={orderList.group_1}
                    onChangeOrder={() => handleSort("group_1")}
                  >
                    <span
                      className="cursor-pointer"
                      onClick={() => handleSort("group_1")}
                    >
                      {groupSetting.group_1.name}
                    </span>
                  </Table.HeadCell>
                )}
                {2 <= levelSelect && (
                  <Table.HeadCell
                    sortable
                    order={orderList.group_2}
                    onChangeOrder={() => handleSort("group_2")}
                  >
                    <span
                      className="cursor-pointer"
                      onClick={() => handleSort("group_2")}
                    >
                      {groupSetting.group_2.name}
                    </span>
                  </Table.HeadCell>
                )}
                {3 <= levelSelect && (
                  <Table.HeadCell
                    sortable
                    order={orderList.group_3}
                    onChangeOrder={() => handleSort("group_3")}
                  >
                    <span
                      className="cursor-pointer"
                      onClick={() => handleSort("group_3")}
                    >
                      {groupSetting.group_3.name}
                    </span>
                  </Table.HeadCell>
                )}
                {4 <= levelSelect && (
                  <Table.HeadCell
                    sortable
                    order={orderList.group_4}
                    onChangeOrder={() => handleSort("group_4")}
                  >
                    <span
                      className="cursor-pointer"
                      onClick={() => handleSort("group_4")}
                    >
                      {groupSetting.group_4.name}
                    </span>
                  </Table.HeadCell>
                )}
                {5 <= levelSelect && (
                  <Table.HeadCell
                    sortable
                    order={orderList.group_5}
                    onChangeOrder={() => handleSort("group_5")}
                  >
                    <span
                      className="cursor-pointer"
                      onClick={() => handleSort("group_5")}
                    >
                      {groupSetting.group_5.name}
                    </span>
                  </Table.HeadCell>
                )}
                <Table.HeadCell
                  className="min-w-[120px] text-center"
                  sortable
                  order={orderList.status}
                  onChangeOrder={() => handleSort("status")}
                >
                  <span
                    className="cursor-pointer"
                    onClick={() => handleSort("status")}
                  >
                    状態
                  </span>
                </Table.HeadCell>
                <Table.HeadCell className="bg-tenken-gray-300 min-w-[120px] text-tenken-tablet-regular xl:text-base"></Table.HeadCell>
                <Table.HeadCell className="bg-tenken-gray-300 text-tenken-tablet-regular xl:text-base text-center w-[92px]">
                  <ButtonTableBulkDelete
                    type="button"
                    onClick={() => handleShowDeleteModal()}
                  />
                </Table.HeadCell>
              </Table.Head>
              <Table.Body className="devide-y text-base">
                {groupRelations.map((row, idx) => (
                  <Table.Row
                    key={idx}
                    className={row.delete ? "!bg-[#FFE7E7]" : ""}
                  >
                    {1 <= levelSelect && (
                      <Table.Cell className="max-w-[240px] truncate">
                        <span title={row.group_1?.name}>{row.group_1?.name}</span>
                      </Table.Cell>
                    )}
                    {2 <= levelSelect && (
                      <Table.Cell className="max-w-[240px] truncate">
                        <span title={row.group_2?.name}>{row.group_2?.name}</span>
                      </Table.Cell>
                    )}
                    {3 <= levelSelect && (
                      <Table.Cell className="max-w-[240px] truncate">
                        <span title={row.group_3?.name}>{row.group_3?.name}</span>
                      </Table.Cell>
                    )}
                    {4 <= levelSelect && (
                      <Table.Cell className="max-w-[240px] truncate">
                        <span title={row.group_4?.name}>{row.group_4?.name}</span>
                      </Table.Cell>
                    )}
                    {5 <= levelSelect && (
                      <Table.Cell className="max-w-[240px] truncate">
                        <span title={row.group_5?.name}>{row.group_5?.name}</span>
                      </Table.Cell>
                    )}
                    <Table.Cell>
                      <span
                        className={`machine-group-update__situation ${
                          row["group_" + levelSelect]?.status
                            ? "bg-[#3BAE4D]"
                            : "bg-[#FA5252]"
                        }`}
                      >
                        {row["group_" + levelSelect]?.status ? "有効" : "無効"}
                      </span>
                    </Table.Cell>
                    <Table.Cell>
                      <div className="flex justify-center align-center">
                        <ButtonTableEdit
                          className="lg:mr-2 mr-1"
                          type="button"
                          onClick={() => handleEditModal(row)}
                        />
                        <ButtonTableDelete
                          type="button"
                          onClick={() => handleShowDeleteModal(row)}
                        />
                      </div>
                    </Table.Cell>
                    <Table.Cell className="text-center">
                      <CheckboxInput
                        position="justify-center"
                        name="delete"
                        checked={row.delete}
                        onChange={(e) => handleCheckDelete(e, idx)}
                        value={row.group_id}
                      />
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          </div>
        </div>
        <div className="w-full md:mt-3 xl:mt-6">
          <div className="xl:flex xl:items-center xl:space-x-2">
            <ButtonAdd type="submit" onClick={() => handleAddModal()}>
              新規追加
            </ButtonAdd>
            <div className="xl:mt-0 mt-3 w-full">
              <Pagination
                setPage={setPage}
                currentPage={page}
                pageSize={perPage}
                setPageSize={setPerPage}
                totalCount={count}
              />
            </div>
          </div>
        </div>
      </div>

      <MachineGroupModal
        title="新しい設備グループを追加する"
        showModal={addModal}
        setShowModal={setAddModal}
        levelSelect={levelSelect}
        groupsList={groupsList}
        groupsChildren={groupsChildren}
        groupData={modalGroupData}
        setModalGroupData={setModalGroupData}
        submitHandler={(e) => handleSubmitAdd(e)}
        formError={formError}
        processing={processing}
      />
      <MachineGroupModal
        title="設備グループを更新する"
        showModal={editModal}
        setShowModal={setEditModal}
        levelSelect={levelSelect}
        groupsList={groupsList}
        groupsChildren={groupsChildren}
        groupData={modalGroupData}
        setModalGroupData={setModalGroupData}
        submitHandler={handleSubmitEdit}
        formError={formError}
        processing={processing}
        update
      />
      <ConfirmDeleteModal
        onConfirm={handleSubmitDelete}
        message={confirmDeleteMessage}
        showModal={deleteModal}
        setShowModal={setDeleteModal}
        onCancel={() => setDeleteModal(false)}
        title={confirmDeleteTitle}
      ></ConfirmDeleteModal>
    </BackendLayout>
  );
}
